module.exports = __webpack_public_path__ + "assets/img/000d9b89228a355ba55fb2901f638fa6.png";